<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ dataOptions.title | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div *ngIf="alertMain" class="mb-2">
            <app-alert [alertSettings]="alertMain"></app-alert>
        </div>
        {{ dataOptions.text | translate }}
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" [disabled]="loadingAction" (click)="close()">{{ 'shared.closeBtn' | translate }}</button>
        <button type="button" class="btn {{dataOptions.button && dataOptions.button.style ? dataOptions.button.style : 'btn-danger'}}" [disabled]="loadingAction" (click)="runAction()">
            <ng-container *ngIf="loadingAction">
                {{ (dataOptions.button ? 'shared.loading' : 'shared.deleting') | translate }}
            </ng-container>
            <ng-container *ngIf="!loadingAction">
                {{ (dataOptions.button ? dataOptions.button.name : 'shared.deleteBtn') | translate }}
            </ng-container>
        </button>
    </div>
</div>
